import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";
import { FaPlug, FaCheckCircle } from "react-icons/fa";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import VuiTooltip from "components/VuiTooltip";
import usePermissions from "hooks/usePermissions";

const AdminIntegrationCard = ({ integration, onConnect }) => {
  const { can } = usePermissions();

  const isConnected = integration.connected;

  return (
    <Card
      sx={{
        height: "100%",
        padding: { xs: 1, lg: 2 },
        background: "linear-gradient(135deg, rgba(255,255,255,0.10), rgba(255,255,255,0.05))",
        backdropFilter: "blur(20px)",
        WebkitBackdropFilter: "blur(20px)",
        border: "1px solid rgba(255, 255, 255, 0.2)",
        boxShadow: "0 8px 32px rgba(0, 0, 0, 0.25)",
      }}
    >
      <VuiBox
        display="flex"
        flexDirection="column"
        alignItems="center"
        height="100%"
        sx={{
          py: { xs: 1, lg: 3 },
          px: { xs: 0, lg: 1 },
        }}
      >
        {/* Header */}
        {/* <VuiBox
          display="flex"
          alignItems="center"
          gap={2}
          flexDirection={{ xs: "column", sm: "row" }}
          textAlign={{ xs: "center", sm: "left" }}
        > */}
        {/* Logo */}
        <VuiBox
          mb={2}
          width="72px"
          height="72px"
          display="flex"
          alignItems="center"
          justifyContent="center"
          borderRadius="12px"
          sx={{ background: "rgba(255,255,255,0.06)" }}
        >
          <img
            src={integration.logoUrl}
            alt={integration.displayName}
            style={{ maxWidth: "48px", maxHeight: "48px" }}
          />
        </VuiBox>

        {/* Name */}
        <VuiTypography variant="h5" fontWeight="regular" textAlign="center">
          {integration.displayName}
        </VuiTypography>

        {/* Description */}
        <VuiTypography variant="caption" textAlign="center" opacity={0.7} mb={0.5} mt={1}>
          {integration.description}
        </VuiTypography>

        <Divider sx={{ width: "100%", my: { xs: 0.8, lg: 1 } }} />

        {/* Status */}
        <VuiBox display="flex" alignItems="center" gap={1} mb={2}>
          {isConnected ? (
            <>
              <FaCheckCircle size={14} color="#4caf50" />
              <VuiTypography variant="caption">Connected {integration.lastSync}</VuiTypography>
            </>
          ) : (
            <>
              <FaPlug size={14} />
              <VuiTypography variant="caption">Not connected</VuiTypography>
            </>
          )}
        </VuiBox>

        {/* Actions */}
        <VuiBox mt="auto" display="flex" gap={1}>
          <VuiTooltip
            title={
              !can("editIntegrations") ? "You do not have permission to manage integrations." : ""
            }
            arrow
            placement="top"
          >
            <span style={{ width: "100%" }}>
              <VuiButton
                fullWidth
                color={isConnected ? "success" : "primary"}
                variant="contained"
                disabled={!can("editIntegrations")}
                onClick={can("editIntegrations") ? () => onConnect(integration) : undefined}
                sx={{
                  opacity: !can("editIntegrations") ? 0.55 : 1,
                  cursor: !can("editIntegrations") ? "not-allowed" : "pointer",
                }}
              >
                {isConnected ? "Manage" : "Connect"}
              </VuiButton>
            </span>
          </VuiTooltip>

          {integration.learnMore && (
            <VuiTooltip title="Learn more about this integration">
              <VuiButton
                fullWidth
                variant="outlined"
                color="primary"
                onClick={() => window.open(integration.learnMore, "_blank")}
              >
                <VuiTypography variant="text" display={{ xs: "none", sm: "block" }}>
                  Learn
                </VuiTypography>{" "}
                <VuiTypography variant="text">More</VuiTypography>
              </VuiButton>
            </VuiTooltip>
          )}
        </VuiBox>
      </VuiBox>
    </Card>
  );
};

export default AdminIntegrationCard;
